"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CompanyUserInfoModal = require("../modal/CompanyUserInfoModal");

var _CompanyUserInfoModal2 = _interopRequireDefault(_CompanyUserInfoModal);

var _PrivateUserInfoModal = require("../modal/PrivateUserInfoModal");

var _PrivateUserInfoModal2 = _interopRequireDefault(_PrivateUserInfoModal);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _RadioGroup = require("../form/RadioGroup");

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RegistrationForm, _Component);

  function RegistrationForm() {
    (0, _classCallCheck3.default)(this, RegistrationForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call(this));

    _this.toggleProUserModal = function () {
      _this.setState({
        showProUserInfoModal: !_this.state.showProUserInfoModal
      });
    };

    _this.toggleFreeUserModal = function () {
      _this.setState({
        showFreeUserInfoModal: !_this.state.showFreeUserInfoModal
      });
    };

    _this.onSubmit = function (values) {
      values.send_transfer_requests = values.send_transfer_requests || false;
      _this.props.register(values);
    };

    _this.state = {
      showProUserInfoModal: false,
      showFreeUserInfoModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(RegistrationForm, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        !this.props.hasDriverLicenseAvailable && _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h4" },
            "REKISTER\xD6IDY PALVELUUMME"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Rekister\xF6im\xE4ll\xE4 maksullisen profiilin saat maap\xF6rssi.fi palvelusta enemm\xE4n. Ammattilaisprofiililla saat k\xE4ytt\xF6\xF6si maaporssi.fi:n kaikki ominaisuudet."
          )
        ),
        this.renderRegistrationForm()
      );
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var registrationError = this.props.auth.registrationError;

      if (registrationError) {
        var text = void 0;
        if (registrationError === "EMAIL_IN_USE") {
          text = "Sähköpostiosoite on jo käytössä.";
        } else if (registrationError === "TOS_NOT_ACCEPTED") {
          text = "Sinun on hyväksyttävä käyttöehdot ja rekisteriseloste.";
        } else {
          text = "Valitettavasti rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen.";
        }
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            text
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/kirjaudu" },
            "Kirjaudu"
          )
        );
      }
    }
  }, {
    key: "renderRegistrationForm",
    value: function renderRegistrationForm() {
      var _props = this.props,
          auth = _props.auth,
          profile = _props.fields.profile;
      var _state = this.state,
          showProUserInfoModal = _state.showProUserInfoModal,
          showFreeUserInfoModal = _state.showFreeUserInfoModal;

      var privateUserTitle = "Yksityisprofiili 120 € profiili / 6 kk (150,60 € sis. alv 25.5%)";
      var companyUserTitle = "Ammattilaisprofiili 225 € profiili / 6 kk (282,40 € sis. alv 25.5%)";

      return _react2.default.createElement(
        "form",
        {
          id: "register",
          className: "col col-xs-12",
          onSubmit: this.props.handleSubmit(this.onSubmit)
        },
        !this.props.hasDriverLicenseAvailable && _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          "Valitse Profiili"
        ),
        !this.props.hasDriverLicenseAvailable && _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_RadioGroup2.default, {
              name: "profile",
              fieldProps: profile,
              options: [{
                id: "profile-professional",
                value: "COMPANY",
                title: companyUserTitle
              }]
            })
          )
        ),
        !this.props.hasDriverLicenseAvailable && this.renderUserHelpText(),
        this.renderRegistrationFields(),
        this.renderTitle(),
        this.renderCompanyFields(),
        this.renderAcceptTos(),
        this.renderSendTransferRequest(),
        this.renderError(),
        this.renderSubmit(),
        _react2.default.createElement(_CompanyUserInfoModal2.default, {
          isShowingModal: showProUserInfoModal,
          handleClose: this.toggleProUserModal
        })
      );
    }
  }, {
    key: "renderRegistrationFields",
    value: function renderRegistrationFields() {
      var _props$fields = this.props.fields,
          email = _props$fields.email,
          first_name = _props$fields.first_name,
          last_name = _props$fields.last_name,
          phone = _props$fields.phone,
          password = _props$fields.password,
          password2 = _props$fields.password2;
      var _props2 = this.props,
          auth = _props2.auth,
          profile = _props2.fields.profile;


      if (profile.value === "") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          "Yhteystiedot"
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "first_name",
              type: "text",
              label: "Etunimi",
              fieldProps: first_name
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "last_name",
              type: "text",
              label: "Sukunimi",
              fieldProps: last_name
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "email",
              type: "email",
              label: "S\xE4hk\xF6posti",
              fieldProps: email
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "phone",
              type: "text",
              label: "Puhelinnumero",
              fieldProps: phone
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Input2.default,
              {
                id: "password",
                type: "password",
                label: "Salasana",
                fieldProps: password
              },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "Salasanan tulee olla 8 merkki\xE4 pitk\xE4."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, {
              id: "password2",
              type: "password",
              label: "Salasana uudelleen",
              fieldProps: password2
            })
          )
        )
      );
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var profile = this.props.fields.profile;

      if (profile.value === "COMPANY") {
        return _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          "Laskutustiedot"
        );
      }
      return null;
    }
  }, {
    key: "renderAcceptTos",
    value: function renderAcceptTos() {
      var tos_accepted = this.props.fields.tos_accepted;
      var profile = this.props.fields.profile;


      if (profile.value) {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Checkbox2.default,
              {
                id: "tos_accepted",
                label: "Hyv\xE4ksyn k\xE4ytt\xF6ehdot ja rekisteriselosteen",
                fieldProps: tos_accepted
              },
              _react2.default.createElement(
                "p",
                { className: "small" },
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: "/kayttoehdot",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  },
                  "Lue k\xE4ytt\xF6ehdot ja rekisteriseloste"
                )
              )
            )
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: "renderSendTransferRequest",
    value: function renderSendTransferRequest() {
      var send_transfer_requests = this.props.fields.send_transfer_requests;
      var profile = this.props.fields.profile;


      if (profile.value !== "COMPANY") {
        return null;
      } else {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Checkbox2.default, {
              id: "send_transfer_requests",
              label: "Haluan kuljetustarjouspyynt\xF6j\xE4 s\xE4hk\xF6postiini",
              fieldProps: send_transfer_requests
            })
          )
        );
      }
    }
  }, {
    key: "renderUserFields",
    value: function renderUserFields() {
      var profile = this.props.fields.profile;

      if (profile.value !== "USER") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "user-fields-js" },
        this.renderPrivateUserPaymentFields(),
        this.renderAddressFields()
      );
    }
  }, {
    key: "renderUserHelpText",
    value: function renderUserHelpText() {
      var profile = this.props.fields.profile;

      if (profile.value === "COMPANY") {
        return this.renderCompanyUserDesc();
      }

      // if (profile.value === "USER") {
      //   return this.renderPrivateUserDesc();
      // }

      return _react2.default.createElement(
        "div",
        null,
        this.renderCompanyUserDesc()
      );
    }
  }, {
    key: "renderPrivateUserDesc",
    value: function renderPrivateUserDesc() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h5",
          null,
          " Yksityisprofiili: "
        ),
        _react2.default.createElement(
          "ul",
          { className: "mp-list" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitusten tarkkojen tietojen lukeminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitukset n\xE4kyv\xE4t kartalla oikeissa paikoissa"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Omien ilmoitusten muokkaaminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ostetut vastaanottolipukkeet talteen omaan profiiliin"
          )
        )
      );
    }
  }, {
    key: "renderCompanyUserDesc",
    value: function renderCompanyUserDesc() {
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h5",
          null,
          "Ammattilaisprofiili "
        ),
        _react2.default.createElement(
          "ul",
          { className: "mp-list" },
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitusten tarkkojen tietojen lukeminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ilmoitukset n\xE4kyv\xE4t kartalla oikeissa paikoissa"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Omien ilmoitusten muokkaaminen"
          ),
          _react2.default.createElement(
            "li",
            null,
            _react2.default.createElement("i", { className: "icon-mp-ok" }),
            "Ostetut vastaanottolipukkeet talteen omaan profiiliin"
          )
        )
      );
    }
  }, {
    key: "renderCompanyFields",
    value: function renderCompanyFields() {
      var _props$fields2 = this.props.fields,
          profile = _props$fields2.profile,
          business_id = _props$fields2.business_id,
          company_name = _props$fields2.company_name;


      if (profile.value !== "COMPANY") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "company-fields-js" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-4" },
            _react2.default.createElement(_Input2.default, {
              id: "business_id",
              type: "text",
              label: "Y-tunnus",
              fieldProps: business_id
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-8" },
            _react2.default.createElement(_Input2.default, {
              id: "company_name",
              type: "text",
              label: "Yritys",
              fieldProps: company_name
            })
          )
        ),
        this.renderAddressFields()
      );
    }
  }, {
    key: "renderPrivateUserPaymentFields",
    value: function renderPrivateUserPaymentFields() {
      var profile = this.props.fields.profile;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            "Palvelu ohjaa sinut Paytrail verkkomaksupalveluun",
            " "
          )
        )
      );
    }
  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var _props3 = this.props,
          auth = _props3.auth,
          profile = _props3.fields.profile;

      if (profile.value === "") {
        return null;
      }

      var submitText = "Maksamaan";
      if (profile.value !== "USER") {
        submitText = "Tilaa";
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_SubmitButton2.default, {
              text: submitText,
              submitting: auth.registrationLoading || false
            })
          )
        )
      );
    }
  }, {
    key: "renderAddressFields",
    value: function renderAddressFields() {
      var _props$fields3 = this.props.fields,
          address = _props$fields3.address,
          postal_code = _props$fields3.postal_code,
          postal_area = _props$fields3.postal_area,
          order_reference = _props$fields3.order_reference,
          profile = _props$fields3.profile;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_Input2.default, {
              id: "address",
              type: "text",
              label: "Katuosoite",
              fieldProps: address
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_code",
              type: "text",
              label: "Postinumero",
              fieldProps: postal_code
            })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, {
              id: "postal_area",
              type: "text",
              label: "Paikkakunta",
              fieldProps: postal_area
            })
          ),
          profile.value === "COMPANY" ? _react2.default.createElement(
            "div",
            { className: "col col-xs-6" },
            _react2.default.createElement(_Input2.default, {
              id: "order_reference",
              type: "text",
              label: "Tilausviite",
              fieldProps: order_reference
            })
          ) : ""
        )
      );
    }
  }]);
  return RegistrationForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  register: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  driverLicenseToken: _react.PropTypes.string
}, _temp);
exports.default = RegistrationForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/registration/RegistrationForm.js
 ** module id = 1185
 ** module chunks = 0
 **/